import axios from "../../utils/axiosConfig";
import { getInvoiceDTO } from "../../dtos/invoice";

axios.defaults.withCredentials = true;

const getInvoice = async (invoice: getInvoiceDTO) => {
  const { data } = await axios.get(
    
      `/api/pharmacy/sales/invoice/details/get?pharmacy_id=${encodeURIComponent(
        invoice.pharmacy_id
      )}&invoice_id=${encodeURIComponent(invoice.invoice_id)}`
  );
  return data;
};

const InvoiceService = {
  getInvoice,
};

export default InvoiceService;
